import { useQuery } from "@tanstack/react-query";
import scraperService from "../services/scraperService";

/**
 * Custom hook for fetching and caching service catalog data
 *
 * Features:
 * - Automatically caches data for 5 minutes
 * - Shows cached data immediately on mount
 * - Refetches in background to check for updates
 * - Only re-renders if data actually changed
 *
 * @returns {Object} Query result with data, loading states, and refetch function
 */
export const useServiceCatalog = () => {
  return useQuery({
    queryKey: ["serviceCatalog"],
    queryFn: async () => {
      const result = await scraperService.fetchServiceCatalog();
      return result;
    },
    staleTime: 1000 * 60 * 5, // Data is fresh for 5 minutes
    gcTime: 1000 * 60 * 10, // Keep in cache for 10 minutes
    refetchOnWindowFocus: true, // Refetch when window regains focus
    refetchOnMount: true, // Refetch on component mount
  });
};
